import React from 'react';
import './MessageUser.css';

export default function MessageUser({ message }) {
    // Highlight links in message
    const renderMessage = (msg) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const parts = String(msg).split(urlRegex);
        return parts.map((part, idx) => {
            if (urlRegex.test(part)) {
                return <a key={idx} href={part} className="message-link-highlight" target="_blank" rel="noopener noreferrer">{part}</a>;
            }
            return part;
        });
    };
    return (
        <div className="message-user-row">
            <div className="message-user-bubble">
                {renderMessage(message)}
            </div>
        </div>
    );
}
